// todo: @vikalp-sajwan this will most probably be api data transformer step

export const apiToGridDirectedChartDataTransformer = (data) => {
  const transformedData = data.map((item) => ({
    id: item.employee.id,
    xValues: item.dataSeries.map((series) => series.score.PERFORMANCE),
    yValues: item.dataSeries.map((series) => series.score.POTENTIAL),
    pointsMetaData: item.dataSeries.map((series) => {
      const hasOverallScore = series.score?.OVERALL !== undefined;
      const hasQnAScore = series.score?.QNA !== undefined;
      const otherDataPoints = [];
      if (hasQnAScore) {
        otherDataPoints.push({
          label: 'Q&A score',
          value: series.score.QNA,
        });
      }
      if (hasOverallScore) {
        otherDataPoints.push({
          label: 'Overall performance score',
          value: series.score.OVERALL,
        });
      }

      return {
        reviewCycle: series.reviewCycle,
        otherDataPoints,
      };
    }),
    seriesMetaData: {
      employee: item.employee,
    },
  }));

  // filter out non plottable points if it has missing data point in x or y axis
  const filteredNonPlottablePointsData = transformedData.map((item) => {
    const filteredXValues = [];
    const filteredYValues = [];
    const filteredPointsMetaData = [];

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < item.xValues.length; i++) {
      const x1 = item.xValues[i];
      const y1 = item.yValues[i];
      if (x1 !== null && x1 !== undefined && y1 !== null && y1 !== undefined) {
        filteredXValues.push(item.xValues[i]);
        filteredYValues.push(item.yValues[i]);
        filteredPointsMetaData.push(item.pointsMetaData[i]);
      }
    }

    return {
      ...item,
      xValues: filteredXValues,
      yValues: filteredYValues,
      pointsMetaData: filteredPointsMetaData,
    };
  });

  const filteredLinesWithoutPlottablePoints = filteredNonPlottablePointsData.filter((item) => item.xValues.length > 0);

  return filteredLinesWithoutPlottablePoints;
};
